import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as WebFont from 'webfontloader';
import { PuzzleFrameworkService } from '../puzzle-framework-module/puzzle-framework.service';

@Injectable({
  providedIn: 'root',
})
export class CrosswordService {
  // This is used to check if the font is loaded.
  // That is needed to calculate the font spacing to fit the text into the definition fields.
  private definitionFontLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly definitionFontLoaded$: Observable<boolean> = this.definitionFontLoaded.asObservable();

  constructor(public framework: PuzzleFrameworkService) {
    // Get the font from the tile.
    const computedStyle = getComputedStyle(document.documentElement);
    let fontName = computedStyle.getPropertyValue('--swedish-definition-cell-font') || 'robotocondensed';

    // If we have a customFont defined in the config, use that one.
    if (framework.puzzleFrameworkConfig.customDefinitionTileFont) {
      fontName = framework.puzzleFrameworkConfig.customDefinitionTileFont;
    }

    WebFont.load({
      custom: {
        families: [fontName],
      },
      active: () => {
        this.definitionFontLoaded.next(true);
      },
    });
  }
}
